const CLINICIAN_CODE_SESSION_KEY = "efa:clinician-portal:clinician-code";

let inMemoryClinicianCode = "";

export function normalizeClinicianCode(value?: string | null): string {
  return value?.trim().toUpperCase() ?? "";
}

function browserSessionStorage(): Storage | null {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function readClinicianCodeSession(): string {
  let storedClinicianCode = "";
  try {
    storedClinicianCode = normalizeClinicianCode(
      browserSessionStorage()?.getItem(CLINICIAN_CODE_SESSION_KEY),
    );
  } catch {
    storedClinicianCode = "";
  }
  if (storedClinicianCode) inMemoryClinicianCode = storedClinicianCode;
  return storedClinicianCode || inMemoryClinicianCode;
}

export function rememberClinicianCodeSession(clinicianCode: string): string {
  const normalizedClinicianCode = normalizeClinicianCode(clinicianCode);
  inMemoryClinicianCode = normalizedClinicianCode;

  const storage = browserSessionStorage();
  if (!storage) return normalizedClinicianCode;

  try {
    if (normalizedClinicianCode) {
      storage.setItem(CLINICIAN_CODE_SESSION_KEY, normalizedClinicianCode);
    } else {
      storage.removeItem(CLINICIAN_CODE_SESSION_KEY);
    }
  } catch {
    // The in-memory fallback still keeps the current portal session usable.
  }
  return normalizedClinicianCode;
}

export function clearClinicianCodeSession(): void {
  inMemoryClinicianCode = "";
  try {
    browserSessionStorage()?.removeItem(CLINICIAN_CODE_SESSION_KEY);
  } catch {
    // There is no persisted session to clear when storage is unavailable.
  }
}

export function clinicianCodeFromSearch(search: string): string {
  return normalizeClinicianCode(
    new URLSearchParams(search).get("clinicianCode"),
  );
}

export function stripClinicianCodeFromCurrentUrl(): void {
  if (typeof window === "undefined") return;

  const url = new URL(window.location.href);
  if (!url.searchParams.has("clinicianCode")) return;

  url.searchParams.delete("clinicianCode");
  window.history.replaceState(
    window.history.state,
    "",
    `${url.pathname}${url.search}${url.hash}`,
  );
}
